<div class="presence-dialog">
  <!-- Auswahlmodus -->
  <div class="field">
    <h3>Auswahlmodus</h3>
    <div class="flex gap-4">
      <div class="flex align-items-center">
        <p-radioButton
          name="auswahlModus"
          value="kurs"
          [(ngModel)]="auswahlModus"
          (onClick)="updateDisabledStates()"
        >
        </p-radioButton>
        <label class="ml-2">Kurs auswählen</label>
      </div>

      <div class="flex align-items-center">
        <p-radioButton
          name="auswahlModus"
          value="teilnehmer"
          [(ngModel)]="auswahlModus"
          (onClick)="updateDisabledStates()"
        >
        </p-radioButton>
        <label class="ml-2">Teilnehmer auswählen</label>
      </div>
    </div>
  </div>

  <!-- Kurs -->
  <p-multiSelect
    [options]="availableMeetings"
    [(ngModel)]="selectedKurs"
    [disabled]="auswahlModus === 'teilnehmer'"
    optionLabel="topic"
    optionValue="meetingId"
    placeholder="Kurs(e) auswählen…"
    appendTo="body"
    scrollHeight="500px"
    (onChange)="onCourseSelected($event.value)"
    >(onChange)="onCourseSelected($event.value)">
  </p-multiSelect>

  <!-- Teilnehmer -->
  <p-multiSelect
    [options]="availableParticipants"
    [(ngModel)]="selectedTeilnehmer"
    [disabled]="auswahlModus === 'kurs'"
    optionLabel="name"
    placeholder="Teilnehmer auswählen…"
    appendTo="body"
    (onChange)="onParticipantSelected($event.value)"
  >
  </p-multiSelect>

  <!-- Monat Dropdown -->
  <div class="field">
    <label for="month">Monat:</label>
    <p-dropdown
      [options]="monate"
      optionLabel="label"
      optionValue="value"
      [(ngModel)]="selectedMonat"
      appendTo="body"
    >
    </p-dropdown>
  </div>

  <!-- Buttons -->
  <div class="button-row">
    <p-button
      [label]="loadingExcel ? 'Excel wird erstellt...' : 'Excel herunterladen'"
      [disabled]="
        loadingExcel ||
        selectedMonat == null ||
        (auswahlModus === 'kurs' && selectedKurs.length === 0) ||
        (auswahlModus === 'teilnehmer' && selectedTeilnehmer.length === 0)
      "
      (onClick)="downloadExcel()"
    >
    </p-button>

    <button
      pButton
      type="button"
      label="Abbrechen"
      icon="pi pi-times"
      class="p-button-secondary"
      (click)="closeDialog()"
    ></button>
  </div>
</div>
